import React from 'react'
import notFound from './assets/img/undraw_not_found_60pq.png'

function PageNotFound() {
    return (
        <div className="row" style={{ "justifyContent": "center", "alignItems": "center", "height": "calc(100vh)" }}>
            <div className="col-md-4">
                <img src={notFound} alt="" style={{ "height": "calc(100vh - 330px)" }} className="img-thumbnail" />
                <h4 style={{ "color": "#173b6c", "textAlign": "center" }}>Page not found!</h4>
            </div>
        </div>
    )
}

export default PageNotFound
